import { useEffect } from 'react'

export function useFormBackground() {
  useEffect(() => {
    document.body.classList.add('form_background')
    return () => {
      document.body.classList.remove('form_background')
    }
  }, [])
}
